export const API_BASE_URL: string =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production"
    ? "https://api.motoscheduler.com/api/v1.0.0/"
    : "http://localhost:8000/api/v1.0.0/");

export const API_URL: string = API_BASE_URL;

export default API_URL;
